import { COLLECTION_NAME_MAX_LENGTH } from '@vizit/constants';
import * as yup from 'yup';

/**
 * The collection name rule shared by create and rename. The name is trimmed first, so a name of only spaces counts
 * as empty and the length limit applies to what is saved.
 */
export const collectionNameSchema = yup
  .string()
  .trim()
  .required('Collection name is required')
  .max(COLLECTION_NAME_MAX_LENGTH, `Please limit collection name to under ${COLLECTION_NAME_MAX_LENGTH} characters`);
